import { createRootRouteWithContext, Outlet } from '@tanstack/react-router'

// import { TanStackRouterDevtools } from '@tanstack/react-router-devtools'
import { AuthContextType } from '../auth-provider/auth-context'
import { UserContextType } from '../user-provider/user-context'

export const Route = createRootRouteWithContext<{
  auth: AuthContextType | undefined
  user: UserContextType | undefined
}>()({
  component: () => {
    return (
      <>
        <Outlet />
        {/* <TanStackRouterDevtools /> */}
      </>
    )
  },
})
